import { observer } from "mobx-react-lite"

import { ManagedSelectionDrawerView } from "./managed-selection-drawer-view"
import type { LockItemDTO } from "./types"

interface ManagedSelectionDrawerObserverProps {
  activeLocks: LockItemDTO[]
  inactiveLocks: LockItemDTO[]
  selectedLockIds: number[]
  onToggleLock: (lockId: number) => void
  onSelectAll: () => void
  onDeselectAll: () => void
  onClose: () => void
}

/**
 * Observer component that renders the drawer view with pre-computed DTOs.
 * The DTOs are already computed in the store with gauge names resolved.
 */
export const ManagedSelectionDrawerObserver = observer(
  ({
    activeLocks,
    inactiveLocks,
    selectedLockIds,
    onToggleLock,
    onSelectAll,
    onDeselectAll,
    onClose,
  }: ManagedSelectionDrawerObserverProps) => {
    // Calculate total power from all locks (active + inactive)
    const allLocks = [...activeLocks, ...inactiveLocks]
    const totalPower = allLocks.reduce((sum, lock) => sum + lock.lockValue, 0)

    return (
      <ManagedSelectionDrawerView
        activeLocks={activeLocks}
        inactiveLocks={inactiveLocks}
        selectedLockIds={selectedLockIds}
        totalPower={totalPower}
        onToggleLock={onToggleLock}
        onSelectAll={onSelectAll}
        onDeselectAll={onDeselectAll}
        onClose={onClose}
      />
    )
  },
)

